import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";

// Trust Apps
import MicrosoftLogo from "../../../images/trust/microsoft.webp";
import MetaLogo from "../../../images/trust/meta.webp";
import OpenaiLogo from "../../../images/trust/openai.webp";
import CdaoLogo from "../../../images/trust/cdao.webp";
import CohereLogo from "../../../images/trust/cohere.webp";
import DefenseLogo from "../../../images/trust/defense.webp";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    color: theme.palette.text.primary,
    backgroundColor: "#000000",
  },
  img: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  cardBody: {
    marginTop: theme.spacing(10),
    backgroundColor: "#000",
    padding: theme.spacing(2),
    backgroundImage: 'url(' + require('../../../images/accelerate-small.svg') + ')',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom right",
    backgroundSize: "90%",
    border: "1px solid #4b4b4a",
    color: "#fff",
  },
  cardBody2: {
    height: `calc(35vh - ${theme.spacing(5)}px)`,
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(6),
    backgroundImage: 'url(' + require('../../../images/strengthen-small.svg') + ')',
    backgroundSize: "50%",
    backgroundPosition: "bottom right",
    backgroundRepeat: "no-repeat",
    padding: theme.spacing(2),
    border: "1px solid #4b4b4a",
    color: "#fff",
  },
  cardBody3: {
    height: `calc(35vh - ${theme.spacing(5)}px)`,
    backgroundImage: 'url(' + require('../../../images/ccp-hero.webp') + ')',
    backgroundSize: "50%",
    backgroundPosition: "bottom right",
    backgroundRepeat: "no-repeat",
    padding: theme.spacing(2),
    color: "#fff",
    border: "1px solid #4b4b4a",
  },
  iconTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    paddingTop: theme.spacing(1),
    width: "100%",
    overflow: "hidden",
    display: "block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#000000",
  },
  title2: {
    fontSize: 28,
    fontWeight: 600,
    paddingTop: theme.spacing(1),
    width: "100%",
    overflow: "hidden",
    display: "block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#fff",
  },
  content: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(5),
    width: 400,
    lineHeight: 2,
    fontSize: "16px",
  },
  productFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "30vh",
    textAlign: "center"
  },
  contentFooter: {
    height: "70vh",
    marginBottom: theme.spacing(10),
  }
}));

export default function Feature2() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Grid container className={classes.productFooter}>
            <Grid item xs={12}>
              <p className={classes.iconTitle}>TRUSTED BY LEADING ORGANIZATIONS</p>
            </Grid>
            <Grid item xs={2}>
              <img src={MicrosoftLogo} width={"40%"} alt="microsoft-logo" />
            </Grid>
            <Grid item xs={2}>
              <img src={MetaLogo} width={"40%"} alt="meta-logo" />
            </Grid>
            <Grid item xs={2}>
              <img src={OpenaiLogo} width={"40%"} alt="openai-logo" />
            </Grid>
            <Grid item xs={2}>
              <img src={CdaoLogo} width={"40%"} alt="cdao-logo" />
            </Grid>
            <Grid item xs={2}>
              <img src={CohereLogo} width={"40%"} alt="cohere-logo" />
            </Grid>
            <Grid item xs={2}>
              <img src={DefenseLogo} width={"40%"} alt="defense-logo" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Grid container className={classes.contentFooter}>
            <Grid item xs={6} className={classes.cardBody}>
              <div>
                <p className={classes.title2}>High Performance</p>
                <div className={classes.content}>Ensure predictable low latency for your most demanding applications.</div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <Grid container>
                <Grid item xs={1} />
                <Grid item xs={11}>
                  <div className={classes.cardBody2}>
                    <p className={classes.title2}>Mission‑Critical Reliability</p>
                    <div className={classes.content}>Ensure that your data is always correct, safe and continuously available.</div>
                  </div>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={11}>
                  <div className={classes.cardBody3}>
                    <p className={classes.title2}>Cypher & Bolt Compatible</p>
                    <div className={classes.content}>Get started in seconds and embrace a rich ecosystem of tools.</div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}